/*
  Fizzy Moo hero flavor switch.
  Pressing a flavor moves the glass thumb, recolors the card highlight and the big
  circle, and shows that flavor's cans. The section works without this script;
  it just stays on the first flavor.
*/
(function () {
  function init(root) {
    if (!root || root.dataset.fmReady === 'true') return;
    root.dataset.fmReady = 'true';
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-fm-flavor-pick]'));
    var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-fm-scene]'));
    if (!options.length) return;

    function pick(option) {
      var id = option.getAttribute('data-fm-flavor-pick');
      root.dataset.flavor = id;
      root.style.setProperty('--fm-flavor', option.getAttribute('data-color') || '#C6E86B');
      root.style.setProperty('--fm-index', option.getAttribute('data-index') || '0');
      options.forEach(function (o) {
        o.setAttribute('aria-pressed', o === option ? 'true' : 'false');
      });
      scenes.forEach(function (s) {
        s.hidden = s.getAttribute('data-fm-scene') !== id;
      });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        pick(option);
      });
    });

    // Arrow keys move between flavors, like a set of tabs.
    root.addEventListener('keydown', function (event) {
      var current = options.indexOf(document.activeElement);
      if (current < 0) return;
      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % options.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + options.length) % options.length;
      if (next === null) return;
      event.preventDefault();
      options[next].focus();
      pick(options[next]);
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-hero]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fm-hero]');
    if (root) init(root);
  });
})();
